var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import RenderIf from 'syf-component-library/ui/atoms/RenderIf';
import { ModalHeader } from 'syf-component-library/ui/patterns/SlideInModalPortal';
import { CAPAutopayStatuses, Flows, RouteSections, Routes } from '../../const';
import { useMainContext } from '../../context';
import useAutopayEnrollment from '../../hooks/use-autopay-enrollment';
import useInitializeApp from '../../hooks/use-initialize-app';
import useModalActions from '../../hooks/use-modal-actions';
import usePlan from '../../hooks/use-plan';
import useSettlement from '../../hooks/use-settlement';
import useTranslation from '../../hooks/use-translation';
import ProgressBar from '../../ui/common/ProgressBar';
import { getCurrentRouteSection } from '../../helpers';
import { useAtom } from 'jotai';
import { StyledBorder } from '../subcomponents';
import CardHeader from './CardHeader';
import { ModalFooter } from './ModalFooter';
import { RenderBody } from './RenderBody';
import { StyledPaymentOptionsModal } from './subcomponents';
var PaymentOptionsModal = function (_a) {
    var atoms = _a.atoms, accountId = _a.accountId, config = _a.config;
    var _b = useAtom(atoms.modalStatusAtom), modalId = _b[0].modalId, updateModalStatus = _b[1];
    var i18n = useTranslation();
    var headerRef = useRef(null);
    var modalTopRef = useRef(null);
    var _c = useMainContext(), currentRoute = _c.currentRoute, setCurrentRoute = _c.setCurrentRoute, setAutopayStatus = _c.setAutopayStatus;
    var appInitialized = useInitializeApp(config, accountId).appInitialized;
    var isOpen = modalId === 'DigitalCollections';
    var isModalReady = appInitialized && isOpen;
    var settlement = useSettlement(isModalReady);
    var plan = usePlan(isModalReady);
    var _d = useAutopayEnrollment(), autopay = _d.autopay, shouldUnenrollAutopay = _d.shouldUnenrollAutopay;
    var handleNavigate = function (feature, mapFlowType) {
        setCurrentRoute(Routes.PAYMENT_OPTIONS);
        if (feature === 'payment') {
            var metadata = mapFlowType
                ? {
                    MAP: {
                        flow: {
                            type: mapFlowType
                        }
                    }
                }
                : undefined;
            updateModalStatus('MAP', modalId, metadata);
        }
    };
    function Unenroll() {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, autopay.mutateAsync()];
                    case 1:
                        _a.sent();
                        setAutopayStatus(CAPAutopayStatuses.WARNING);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        setAutopayStatus(CAPAutopayStatuses.ERROR);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    var isSettlementRoute = currentRoute.includes(Flows.SETTLEMENT);
    var currentFlow = isSettlementRoute ? settlement : plan;
    var _e = useModalActions(updateModalStatus, currentFlow, handleNavigate, accountId), getPrimaryAction = _e.getPrimaryAction, getSecondaryAction = _e.getSecondaryAction, handleCloseModal = _e.handleCloseModal;
    /** Used to scroll to the top of the modal upon page change */
    useEffect(function () {
        if (modalTopRef.current) {
            modalTopRef.current.scrollIntoView();
        }
        if (shouldUnenrollAutopay) {
            Unenroll();
        }
        else if (currentRoute === Routes.PLAN_SUCCESS && currentFlow === plan) {
            setAutopayStatus(CAPAutopayStatuses.INFO);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentRoute]);
    var getModalHeader = function () {
        var currentSection = getCurrentRouteSection(currentRoute);
        switch (currentSection) {
            case RouteSections.SETTLEMENT:
                return i18n('paymentOptions.settlementCardHeading');
            case RouteSections.PLAN:
                return i18n('paymentOptions.customerAssistanceCardHeading');
            default:
                return i18n('paymentOptions.modalHeading');
        }
    };
    var onCloseModal = function () {
        setAutopayStatus(null);
        handleCloseModal();
    };
    var isErrorRoute = currentRoute === Routes.PLAN_ERROR ||
        currentRoute === Routes.SETTLEMENT_ERROR;
    return (_jsxs(StyledPaymentOptionsModal, __assign({ isOpen: isOpen, containerId: "dc-modal-container", id: "other-options", escapeModalHandler: onCloseModal, header: _jsx(ModalHeader, { headerRef: headerRef, closeModal: onCloseModal, content: getModalHeader(), closeButtonAriaLabel: "Close dialog", dataType: "dch", dataReason: "x button" }), footer: _jsx(ModalFooter, { primaryButton: getPrimaryAction(), secondaryButton: getSecondaryAction() }) }, { children: [_jsx("div", { ref: modalTopRef }), _jsx("div", { id: "nfcc-container" }), _jsx(RenderIf, __assign({ condition: !isErrorRoute }, { children: _jsxs(_Fragment, { children: [_jsx(CardHeader, {}), _jsx(StyledBorder, {}), _jsx(ProgressBar, {})] }) })), _jsx(RenderBody, { isModalReady: isModalReady, settlement: settlement, plan: plan, navigateTo: handleNavigate })] })));
};
export default PaymentOptionsModal;
//# sourceMappingURL=index.js.map